"use strict";
import { eventsHideNums,locName,showItem } from "./b-filter";
var weizhiding = "&#xe618;";
var yizhiding = "&#xe602;";
var weishoucang = "&#xe601;";
var yishoucang = "&#xe694;";

export function showImg() { //动态图片ing dont haved
	if($(".ing").find('.b-content>li[style="display: block;"]').length > 0) {
		$(".ing>img").css({
			'display': 'block'
		})
	} else {
		$(".ing>img").css({
			'display': 'none'
		})
	}
	if($(".dont").find('.b-content>li[style="display: block;"]').length > 0) {
		$(".dont>img").css({
			'display': 'block'
		})
		$("footer").css({
			'display': 'block'
		})
	} else {
		$(".dont>img").css({
			'display': 'none'
		})
	}
	if($(".haved").find('.b-content>li[style="display: block;"]').length > 0) {
		$(".haved>img").css({
			'display': 'block'
		})
	} else {
		$(".haved>img").css({
			'display': 'none'
		})
	}
}

//选中--------------------------------------------------------------------
export function eventFun() {
	var chooseArr = [];
	$(".b-content").on("click", "input:checkbox[name='subCheckbox']", function() {
		var strEnd = locName();
		chooseArr = localStorage.getItem(strEnd+"-chooseItem")?localStorage.getItem(strEnd+"-chooseItem").split(","):[];
		if($(this).prop("checked")) { //    子按钮选中
			$(this).parent().parent().parent().parent().addClass('preHide'); //准备隐藏类名
			chooseArr[chooseArr.length] = $(this).parent().parent().parent().parent().data("id");
		} else { //    子按钮取消
			$(this).parent().parent().parent().parent().removeClass('preHide'); //准备隐藏类名
			for(var i = 0; i < chooseArr.length; i++) {
				if(chooseArr[i] == $(this).parent().parent().parent().parent().data("id")) {
					chooseArr.splice(i, 1);
				}
			}
		}
		localStorage.setItem(strEnd+"-chooseItem", chooseArr.join(",")); //存入仓库
	});
	$(".hideChoose").click(function() { // 左侧隐藏按钮
		var strEnd = locName();
		var hideChoose = localStorage.getItem(strEnd+"-hideChoose")
	    if(!hideChoose){
	    	localStorage.setItem(strEnd+"-hideChoose",1);
			$('.preHide').css({
				'display': 'none'
			}); //隐藏li
			$("input:checkbox[name='allCheckbox']").prop("checked", false);
			showItem();
			showImg();
			eventsHideNums();
		}else{
	    	localStorage.setItem(strEnd+"-hideChoose","");
			returnChoose();
			showItem();
	    }
	});
	$(".left-fixed").on("click", ".keepChoose", function() { //  左侧保留勾选按钮
		var strEnd = locName();
		var keepChoose = localStorage.getItem(strEnd+"-keepChoose");
	    if(!keepChoose){
	    	localStorage.setItem(strEnd+"-keepChoose",1);
			var preHide = $('.preHide');
			var arr = []
			for (var i=0; i<preHide.length; i++) {
				if($(preHide[i]).css("display")=="block"){
					arr.push($(preHide[i]))
				}
			}
			$('.baskClass li').css({
				'display': 'none'
			}); //隐藏li
			for (var i=0; i<arr.length; i++) {
				arr[i].css('display','block');
			}
	
			$("input:checkbox[name='allCheckbox']").prop("checked", false); //  还原总按钮初始状态
			showItem();
			showImg();
			eventsHideNums();
		}else{
	    	localStorage.setItem(strEnd+"-keepChoose","");
			returnChoose();	
			showItem();
	    }
	});
}
// //完整按钮-----------------------------------------------------------
function returnChoose() {
	//      $(".returnChoose").on("click",function () {
	var strEnd = locName();
	if(strEnd.indexOf("lanqiu")!=-1){
		window.localStorage.removeItem(strEnd+"-saishiItem");
		window.localStorage.removeItem(strEnd+"-item");
	}
	$(".b-content li").css({
		'display': 'block'
	})
	$('.b-content>li[data-zhiding="weizhiding"]').css({
		'display': 'none'
	}); //*置顶被克隆的会添加weizhiding值,用来判断显示时不显示被克隆元素;
	//          window.localStorage.removeItem(strEnd+"-b-chooseItem");
//	window.localStorage.removeItem(strEnd + "-b-saishiItem");
//	if(window.location.href.indexOf("saicheng") != -1) {
//		window.localStorage.removeItem("bs-iscollectItem");
//	} else {
//		window.localStorage.removeItem("b-iscollectItem");
//	}
	$('.v-li-3').addClass('redBgc');
	$('.v-li-4').removeClass('redBgc');
	$('.v-li-10').removeClass('redBgc');
	$("input:checkbox[name='saishiCheck']").prop("checked", true);
	if(typeof showImg === "function") {
		showImg();
	}
	$(".returnChoose").html("完整");
	//      });
}
//页面一开始加载的时候找到仓库的值隐藏起来
export function loadingChoose() {
	var strEnd = locName();
	var getChooseItem = localStorage.getItem(strEnd+"-chooseItem")?localStorage.getItem(strEnd+"-chooseItem").split(","):[];
	if(getChooseItem) {
		for(var i = 0, ilen = getChooseItem.length; i < ilen; i++) {
			$(".baskClass li[data-id='" + getChooseItem[i] + "']").addClass("preHide")
		}
		$("li.preHide input:checkbox[name='subCheckbox']").prop("checked", true);	
		showImg();
		eventsHideNums();
	}
}

//收藏--------------------------------------------------------------------
export function collectFun(day) {
	$(".b-content").on("click", ".no-shoucang", function() {
		var strEnd = locName();
		$(this).addClass('yi-shoucang icon-color-red').removeClass('no-shoucang icon-color-grey');
		$(this).html(yishoucang);
		var getCollectItem = localStorage.getItem(strEnd+"-collectItem"); //收藏
		getCollectItem ? getCollectItem = JSON.parse(getCollectItem) : getCollectItem = []; // 仓库无值变数组
		getCollectItem[getCollectItem.length] = $(this).parent().parent().parent().parent().parent().data("id");; // 保存id
		localStorage.setItem(strEnd+"-collectItem", JSON.stringify(getCollectItem)); //存入仓库
	});
	$(".b-content").on("click", ".yi-shoucang", function() {
		var strEnd = locName();
		$(this).addClass('no-shoucang icon-color-grey').removeClass('yi-shoucang icon-color-red');
		$(this).html(weishoucang);
		var collectArr = $(this).parent().parent().parent().parent().parent().data("id");
		var getCollectItem = JSON.parse(localStorage.getItem(strEnd+"-collectItem")); //取消收藏,保存到仓库
		for(var _i2 = 0; _i2 < getCollectItem.length; _i2++) { //循环仓库对应删除
			if(getCollectItem[_i2] == collectArr) {
				getCollectItem.splice(_i2, 1);
			}
		}
		localStorage.setItem(strEnd+"-collectItem", JSON.stringify(getCollectItem));
	});
	$(".left-fixed").on("click", ".collectChoose", function() { // 左侧只看收藏按钮
		collectChooseFn();
		showItem();
	});
}
export function collectChooseFn() { //页面加载渲染收藏列表
	var strEnd = locName();
	// 思路: 循环所有的tr列表,和本地收藏仓库collectItem一致的data-id就显示,否则隐藏
	var trNums = $(".baskClass>ul>li");
	var getCollectItem = window.localStorage.getItem(strEnd+"-collectItem");
	if(getCollectItem) {
		//  	localStorage.setItem("b-iscollectItem","1")
		//        if (JSON.parse(getCollectItem).length > 0) {
//		trNums.css({
//			'display': 'none'
//		})
		//        }
		getCollectItem = JSON.parse(getCollectItem);
		//    循环仓库
		for(var j = 0; j < trNums.length; j++) {
			for(var i = 0; i < getCollectItem.length; i++) {
			//    循环tr列表
				if(getCollectItem[i] == $(trNums[j]).data("id")) {
					break;
				}
				if(i==getCollectItem.length-1){
					$(trNums[j]).css({
						'display': 'none'
					});
				}
			}
		}
		$('.b-content>li[data-zhiding="weizhiding"]').css({
			'display': 'none'
		}); //*置顶被克隆的会添加weizhiding值,用来判断显示时不显示被克隆元素;
	} else {
		trNums.css({
			'display': 'none'
		})
	}
	showImg();
	eventsHideNums();
}
export function startLoad_collect() { //页面加载渲染收藏列表
	var strEnd = locName();
	var getCollectItem = window.localStorage.getItem(strEnd+"-collectItem");
	var j = 0;
	if(getCollectItem) {
		getCollectItem = JSON.parse(getCollectItem);
		for(var i = 0; i < getCollectItem.length; i++) {
			//console.log(getCollectItem[i])
			if($(".baskClass").find("li[data-id=" + getCollectItem[i] + "]").find(".no-shoucang").length == 0) {
				j++
			} else {
				$(".baskClass").find("li[data-id=" + getCollectItem[i] + "]").find(".no-shoucang").addClass('yi-shoucang icon-color-red').removeClass('no-shoucang icon-color-grey').html(yishoucang);
			}
		}
//		if(getCollectItem.length - j <= 0) {
//			window.localStorage.removeItem(strEnd+"-collectItem")
//			//    	if(localStorage.getItem("b-iscollectItem")){
//			//					collectChooseFn()
//			//				}
//		}
	}
}

//置顶-------------------------------------------------------------------
export function goToTop(fn) {
	$(".b-fixed").on("click", ".top-img", function() {
		$(this).addClass('icon-color-red');
		$(this).html(yizhiding);
		$(this).parent().parent().parent().parent().parent().clone(true).appendTo($(".b-top>ul")).attr('data-zhiding', 'zhiding');;
		$(this).parent().parent().parent().parent().parent().css({
			'display': 'none'
		}).attr('data-zhiding', 'weizhiding');
		// 获取tr的data-id string
		var trData = $(this).parent().parent().parent().parent().parent().data("id");

		var getTopItem = window.localStorage.getItem("b-topItem");
		// 保存到localstorage 逻辑:判断仓库有值就用JSON.parse把string转换成array,没值就赋[]变array
		if(getTopItem) {
			getTopItem = JSON.parse(getTopItem);
		} else {
			getTopItem = [];
		}
		//tr的data-id 插入到数组并保存到本地仓库
		getTopItem[getTopItem.length] = trData;
		window.localStorage.setItem("b-topItem", JSON.stringify(getTopItem));

		$(".basketball-inner>.title").css({
			'display': 'block'
		})
		$(".b-top").off("mouseenter", ".iszb");
		$(".f-top").off("mouseleave", ".iszb");
		$(".b-top").on("mouseenter", ".iszb", function() {
			fn($(this).parent().parent().parent().parent().parent().data("id"))
		})
		$(".b-top").on("mouseleave", ".iszb", function() {
			fn($(this).parent().parent().parent().parent().parent().data("id"),1)
		})
		showImg();
	});
	$(".b-top").on("click", ".top-img", function() { // 取消置顶
		$(this).parent().parent().parent().parent().parent().remove();

		var trData = $(this).parent().parent().parent().parent().parent().data("id");

		$(".b-fixed li[data-id=" + trData + "]").css({
			'display': 'block'
		}).removeAttr('data-zhiding').find(".top-img").html(weizhiding).removeClass('icon-color-red');

		var getTopItem = window.localStorage.getItem("b-topItem");
		//  取消localstorage对应的值  逻辑: getItem拿到并删除setItem里面的对应的数据,然后重新赋值给setItem
		getTopItem = JSON.parse(getTopItem);
		for(var i = 0; i < getTopItem.length; i++) {
			if(getTopItem[i] == trData) {
				getTopItem.splice(i, 1);
				break;
			}
		}
		//  更新本地仓库
		window.localStorage.setItem("b-topItem", JSON.stringify(getTopItem));
		//  没值隐藏顶部的清除置顶
		if(getTopItem.length == 0) {
			$(".basketball-inner>.title").css({
				'display': 'none'
			})
		}
		showImg();
	});
	$(".top_clear").on("click", function() { //  清除置顶
		$(".b-top ul").empty();

		$(".b-fixed .b-content").find(".top-img").html(weizhiding).removeClass('icon-color-red');
		//    不能全部显示,不然隐藏勾选的会出现
		// $(".b-fixed li").css({'display':'block'})

		//    思路:循环置顶仓库的值,找到对应的显示回去
		var getTopItem = window.localStorage.getItem("b-topItem");
		if(getTopItem) {
			getTopItem = JSON.parse(getTopItem);
			//    获取所有li的个数
			var liNums = $(".b-fixed>ul>li");
			// console.log(liNums);
			//    循环置顶仓库的值
			for(var i = 0; i < getTopItem.length; i++) {
				//    找到对应的f-fixed里面的data-id让他show
				for(var j = 0; j < liNums.length; j++) {
					if(getTopItem[i] == $(liNums[j]).data("id")) {
						$(liNums[j]).css({
							'display': 'block'
						})
					}
				}
			}
		}

		window.localStorage.removeItem("b-topItem");

		$(".basketball-inner>.title").css({
			'display': 'none'
		})
		showImg()
	});
}

export function startLoad(fn) { //  页面加载置顶
	var getTopItem = window.localStorage.getItem("b-topItem");
	if(getTopItem) {
		getTopItem = JSON.parse(getTopItem);
		for(var i = 0, ilen = getTopItem.length; i < ilen; i++) {
			$(".b-fixed").find("li[data-id=" + getTopItem[i] + "]").find(".top-img").html(yizhiding).addClass('icon-color-red');
			$(".b-fixed").find("li[data-id=" + getTopItem[i] + "]").clone(true).appendTo($(".b-top>ul")).attr('data-zhiding', 'zhiding');;;
			$(".b-fixed").find("li[data-id=" + getTopItem[i] + "]").css({
				'display': 'none'
			}).attr('data-zhiding', 'weizhiding');
		}
		if(getTopItem.length == 0) {
			$(".basketball-inner>.title").css({
				'display': 'none'
			})
		} else {
			$(".basketball-inner>.title").css({
				'display': 'block'
			})
		}
		$(".b-top").off("mouseenter", ".iszb");
		$(".f-top").off("mouseleave", ".iszb");
		$(".b-top").on("mouseenter", ".iszb", function() {
			fn($(this).parent().parent().parent().parent().parent().data("id"))
		})
		$(".b-top").on("mouseleave", ".iszb", function() {
			fn($(this).parent().parent().parent().parent().parent().data("id"),1)
		})
	}
}

//开启声音----------------------------------------------------------------
export function soundSwitch() {
	$('.b-fixed').on('click', '.in-sound', function() {
		var that = $(this)
		that.toggleClass('icon-color-red');
		var id_one = that.parent().parent().parent().parent().parent().attr('data-id');
		var getSoundItem = window.localStorage.getItem("on-soundItem");
		//  保存到localstorage 逻辑:判断仓库有值就用JSON.parse把string转换成array,没值就赋[]变array
		if(getSoundItem) {
			getSoundItem = JSON.parse(getSoundItem);
		} else {
			getSoundItem = [];
		}
		if(that.hasClass('icon-color-red')) { //  开启声音值添加到数组
			getSoundItem[getSoundItem.length] = id_one
		} else { //  关闭声音去掉数组对应值
			for(var i = 0, ilen = getSoundItem.length; i < ilen; i++) {
				if(getSoundItem[i] == id_one) {
					getSoundItem.splice(i, 1);
				}
			}
		}
		window.localStorage.setItem("on-soundItem", JSON.stringify(getSoundItem));
	})
}

export function startLoad_sound() { //  页面加载
	var getSoundItem = window.localStorage.getItem("on-soundItem");
	if(getSoundItem) {
		getSoundItem = JSON.parse(getSoundItem);
		for(var i = 0, ilen = getSoundItem.length; i < ilen; i++) {
			$(".b-fixed").find("li[data-id=" + getSoundItem[i] + "]").find(".in-sound").addClass('icon-color-red');
		}
	}
}

//播放声音----------------------------------------------------------------
export function goalSoundClick() {
	$(".view-sound").hover(function() {
		$(".view-sound .slidedown").css({
			'display': 'block'
		})
	}, function() {
		$(".view-sound .slidedown").css({
			'display': 'none'
		})
	});
	$(".view-sound .slidedown li").mouseenter(function() { //  切换颜色
		$(this).addClass("m-active");
		$(this).siblings().removeClass("m-active");
	});
	$(".view-sound .slidedown li").click(function() { //  切换文字
		$(".view-sound span").html($(this).html());
		window.localStorage.setItem("b-soundItem", $(this).html());
	});
	$(".view-sound .sound-0").click(function() { //  选取音效 保存到仓库
		window.localStorage.setItem("b-soundItem", 0);
	});
	$(".view-sound .sound-1").click(function() {
		window.localStorage.setItem("b-soundItem", 1);
		goalSound();
	});
	$(".view-sound .sound-2").click(function() {
		window.localStorage.setItem("b-soundItem", 2);
		goalSound();
	});
	if(!localStorage.getItem("b-soundItem")) { // 初始化音效
		window.localStorage.setItem("b-soundItem", 1);
	}
	if(localStorage.getItem("b-soundItem")) { //  初始化音效文字
		var soundText = ['静音', '默认', '撞击'];
		$(".view-sound span").html(soundText[localStorage.getItem("b-soundItem")]);
	}
}

export function goalSound() {
	if(window.localStorage.getItem("b-soundItem")) { //0是静音不用播放
		new Audio("/sounds/b-sounds/" + window.localStorage.getItem("b-soundItem") + ".mp3").play();
	}
}